import React, { FC } from 'react';
import styled from 'styled-components';
import { CatalogListSkeleton } from 'src/components/widgets/catalogList';
import {
    SkeletonBlock,
    SkeletonLeftSidebar,
    SkeletonLeftSidebarContent,
    SkeletonLeftSidebarLayout,
    SkeletonPageHeader,
    SkeletonPageShell,
    SkeletonRow,
    SkeletonStack
} from 'src/components/widgets/skeleton';

const ShapesSkeletonShell = styled(SkeletonPageShell).attrs({ $padding: '20px 0 92px' })``;

const ShapesSkeletonHeader = styled(SkeletonPageHeader)``;

const ShapesSkeletonLayout = styled(SkeletonLeftSidebarLayout)``;

const ShapesSidebarSkeleton = styled(SkeletonLeftSidebar)``;

const ShapesToolbarSkeleton = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 18px;
    margin-bottom: 18px;
    min-width: 0;

    @media (max-width: 700px) {
        align-items: stretch;
        flex-direction: column;
    }
`;

export const ShapesPageSkeleton: FC = () => (
    <ShapesSkeletonShell aria-hidden='true'>
        <ShapesSkeletonHeader>
            <SkeletonStack $gap='8px' $flex='1'>
                <SkeletonBlock $width='min(260px, 100%)' $height='26px' />
                <SkeletonBlock $width='min(520px, 100%)' $height='13px' />
            </SkeletonStack>
            <SkeletonRow $gap='8px'>
                <SkeletonBlock $width='84px' $height='36px' $radius='6px' />
                <SkeletonBlock $width='128px' $height='36px' $radius='6px' />
            </SkeletonRow>
        </ShapesSkeletonHeader>
        <ShapesSkeletonLayout>
            <ShapesSidebarSkeleton>
                <SkeletonStack $gap='12px'>
                    <SkeletonBlock $width='70%' $height='16px' />
                    {Array.from({ length: 7 }).map((_, index) => (
                        <SkeletonRow key={index} $gap='10px'>
                            <SkeletonBlock $width='18px' $height='18px' $radius='4px' />
                            <SkeletonBlock $width={index % 2 === 0 ? '78%' : '56%'} $height='13px' />
                        </SkeletonRow>
                    ))}
                </SkeletonStack>
            </ShapesSidebarSkeleton>
            <SkeletonLeftSidebarContent>
                <CatalogListSkeleton itemsCount={15}>
                    <ShapesToolbarSkeleton>
                        <SkeletonRow $gap='10px'>
                            <SkeletonBlock $width='104px' $height='32px' $radius='16px' />
                            <SkeletonBlock $width='84px' $height='32px' $radius='16px' />
                        </SkeletonRow>
                        <SkeletonBlock $width='min(500px, 100%)' $height='38px' $radius='6px' />
                    </ShapesToolbarSkeleton>
                </CatalogListSkeleton>
            </SkeletonLeftSidebarContent>
        </ShapesSkeletonLayout>
    </ShapesSkeletonShell>
);
